// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded
async.push(["ready", function() {
    // calculate listing weekly payment
    initWeeklyPrices();
}]);

// update per week prices for each listing
window.initWeeklyPrices = function initWeeklyPrices(modal){
    // console.log(Cookies.get('loandeposit'), Cookies.get('loaninterestrate'), Cookies.get('loanterm'), );

    // get calculator values from user cookie or default values
    var interestrate = default_interest_rate;
    var loanterm = default_term;
    var deposit = default_deposit;
    var frequency = default_frequency;

    // if(Cookies.get('loaninterestrate') !== undefined){
    //     // console.log(Cookies.get('loaninterestrate'));
    //     interestrate = Cookies.get('loaninterestrate');
    // }
    // if(Cookies.get('loanterm') !== undefined){
    //     loanterm = Cookies.get('loanterm');
    // }
    // if(Cookies.get('loandeposit') !== undefined){
    //     deposit = Cookies.get('loandeposit');
    // }
    // if(Cookies.get('loanpaymentfrequency') !== undefined){
    //     frequency = Cookies.get('loanpaymentfrequency');
    // }

    // $('.list-payment-freq').text(frequency);

    // limit to modal
    let elem = '.listing-weekly-price';
    if (modal) {
        elem = modal + ' .listing-weekly-price';
    }

    // calculate weekly prices
    $(elem).each(function(){
        var vehicleprice = Number($(this).data('vehicleprice'));

        if(vehicleprice > 0){


            deposit = Number(deposit);
            if(deposit > vehicleprice){
                deposit = (vehicleprice - 1000); // set to default deposit if greater than vehicle price
            }
            var loan_amount = (vehicleprice - deposit).toFixed(2);

            // console.log('values: ', vehicleprice, Number(deposit), loan_amount, interestrate, loanterm);


            // calculate the loan info
            var loan_info = $.loanInfo({
                amount: loan_amount,
                rate: interestrate+'%',
                term: loanterm+'m',
                frequency: frequency
            });

            var weeklyAmount = Math.ceil(loan_info.payment_amount).toFixed(0);
            // log the calculation data for test purposes
            //console.log( loan_info );
            let prevElement = $(this).prev().prop('nodeName');
            if (prevElement == 'SUP') {
                $(this).text(weeklyAmount);
            }else if(loan_info.payment_amount_formatted !== 'undefined'){
                $(this).text('$'+ weeklyAmount);
            }else{
                $(this).text('$TBC');
            }
        }else{
            $(this).text('$TBC');
        }
    });
}